/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CostStatisticDto } from '../../models/cost-statistic-dto';
import { GetBasicCostStatisticRequest } from '../../models/get-basic-cost-statistic-request';

export interface GetBasicCostStatistics$Params {
      body: GetBasicCostStatisticRequest
}

export function getBasicCostStatistics(http: HttpClient, rootUrl: string, params: GetBasicCostStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CostStatisticDto>>> {
  const rb = new RequestBuilder(rootUrl, getBasicCostStatistics.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CostStatisticDto>>;
    })
  );
}

getBasicCostStatistics.PATH = '/v0/costStatistics/basic';
